import { RootState } from 'editor/src/store/index';

const getAddonById = (state: RootState, addonId: string) =>
  state.editorModules.addons.inUse?.find((addon) => addon.id === addonId);

export default getAddonById;
